import React, { Component } from "react";
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import StyleLink from './dev/StyleLink'
import StarIcon from './icon/StarIcon'
import SearchIcon from './icon/SearchIcon'
import UserIcon from './icon/UserIcon'
import LotteyIcon from './icon/LotteyIcon'
import ArrowIcon from "@material-ui/icons/ExpandMore";

const { REACT_APP_URI = "/" } = process.env;

class Sidebar extends Component { 
    state = {
        isFavoriteChannelsLoading: true,
        isFavoriteChannelsOpen: false,
        isRecentChannelsLoading: true,
    }
    componentDidMount() {
        const { user:{ plan } } = this.props;
        this.getFavoriteChannels();
        this.getRecentChannels();
    }
    getFavoriteChannels = () => {
        fetch(`${REACT_APP_URI}/FavoriteChannels/`, { credentials: "include" })
        .then(res => {
            if(res.ok) return res.json()
            else throw res;
        })
        .then(res => this.props.dispatch({ 
            type: 'setFavoriteChannels', 
            favoriteChannels: res.favoriteChannels,
        }))
        .then(() => this.setState({ isFavoriteChannelsLoading: false}))
    }
    getRecentChannels = () => {
        fetch(`${REACT_APP_URI}/RecentChannels/`, { credentials: "include" })
        .then(res => {
            if(res.ok) return res.json()
            else throw res;
        })
        .then(res => this.props.dispatch({ 
            type: 'setRecentChannels', 
            recentChannels: res.recentChannels,
        }))
        .then(() => this.setState({ isRecentChannelsLoading: false}))
    }
    renderSideBarList = ({ name, url, icon, id }, pathname) => {
        return (
            <StyleLink to={url} onClick={() => window.scrollTo(0,0)}>
                <SidebarContentWrap id={id} isFocused={pathname === url}>
                    {this.renderIcon(icon)}
                    <SidebarContent>{name}</SidebarContent>
                </SidebarContentWrap>
            </StyleLink>
        )
    }
    renderIcon = icon => {
        return (
            <React.Fragment>
                {icon === StarIcon && <StarIcon />}
                {icon === SearchIcon && <SearchIcon />}
                {icon === UserIcon && <UserIcon />}
                {icon === LotteyIcon && <LotteyIcon/>}
            </React.Fragment>
        )
    }
    renderFavoriteChannels = () => {
        const { user:{ auth, plan } } = this.props;
        const {isFavoriteChannelsLoading, isFavoriteChannelsOpen} = this.state
        const { favorite: {favoriteChannels}, messages} = this.props
        const newFavoriteChannels = isFavoriteChannelsOpen ? favoriteChannels : favoriteChannels.length < 5 ? favoriteChannels : favoriteChannels.slice(0,5)
        return (
            <ChannelsWrap>
                <ChannelsTitle>{this.props.messages.sidebar_favorite} ({favoriteChannels.length})</ChannelsTitle>
                {isFavoriteChannelsLoading ? <Channel onClick={() => 
                    auth === "notSignIn" 
                    ? this.props.dispatch({ type: "toggleUserField", condition: "signIn" })
                    : plan === "Free" || plan === "Creator" 
                        ? this.props.dispatch({ 
                            type: 'togglePaymentField', 
                            isPaymentGuideActive: true,
                            paymentGuideMinPlan: "Brand",})
                        : ""}>
                    <Avatar isLoading/>
                    <ChannelContext isLoading></ChannelContext>
                </Channel> : 
                    newFavoriteChannels.map(channel => <StyleLink 
                        to={`/Info/${channel.infoId}`} 
                        target={"_blank"}>
                    <Channel>
                        <Avatar imgUrl={channel.avatar}/>
                        <ChannelContext title={channel.title}>{channel.title}</ChannelContext>
                    </Channel>
                </StyleLink>)}
                {!isFavoriteChannelsOpen && favoriteChannels.length > 5 && <Channel onClick={() => this.setState({ isFavoriteChannelsOpen: !isFavoriteChannelsOpen})}>
                    <Avatar>
                        <ArrowIconWrap>
                            <ArrowIcon width={"12px"} height={"12px"}/>
                        </ArrowIconWrap>
                    </Avatar>
                    <ChannelContext>{messages.sidebar_show_more}</ChannelContext>
                </Channel>}
            </ChannelsWrap>
        )
    }
    renderRecentChannels = () => {
        const {isRecentChannelsLoading} = this.state
        const { recent: {recentChannels}} = this.props
        const { user:{ auth, plan } } = this.props;
        return (
            <ChannelsWrap>
                <ChannelsTitle>{this.props.messages.sidebar_recent}</ChannelsTitle>
                {isRecentChannelsLoading ? <Channel onClick={() => 
                    auth === "notSignIn" 
                    ? this.props.dispatch({ type: "toggleUserField", condition: "signIn" })
                    : plan === "Free" || plan === "Creator" 
                        ? this.props.dispatch({ 
                            type: 'togglePaymentField', 
                            isPaymentGuideActive: true,
                            paymentGuideMinPlan: "Brand",})
                        : ""}>
                    <Avatar isLoading/>
                    <ChannelContext isLoading></ChannelContext>
                </Channel> : 
                    recentChannels.map(channel => <StyleLink to={`/Info/${channel.infoId}`} target={"_blank"}>
                    <Channel>
                        <Avatar imgUrl={channel.avatar}/>
                        <ChannelContext title={channel.title}>{channel.title}</ChannelContext>
                    </Channel>
                </StyleLink>)}
            </ChannelsWrap>
        )
    }
    render() {
        const { pathname } = this.props.location
        const { messages, user:{ plan } } = this.props
        const SideBarList = [
            { name: messages.slide_ranking, url: '/', icon: StarIcon },
            { name: messages.slide_search, url: '/InfoList', icon: SearchIcon },
            { name: messages.slide_project_management, url: '/Proposal', icon: UserIcon, id:"sidebar_prposalList" },
            { name: messages.slide_lottery, url: '/Lottery', icon: LotteyIcon },
        ]
        return (
            <SidebarWrap>
                {SideBarList.map(list => this.renderSideBarList(list, pathname))}
                {this.renderFavoriteChannels()}
                {this.renderRecentChannels()}
            </SidebarWrap>
        )
    }
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        user: state.User,
        payment: state.Payment,
        favorite: state.FavoriteChannels,
        recent: state.RecentChannels,
    }
}
export default withRouter(connect(mapStateToProps)(Sidebar));
const SidebarWrap = styled.div`
    position: fixed;
    min-height: calc(100vh - 72px);
    max-height: calc(100vh - 72px);
    width: 180px;
    top: 72px ;
    left: 0;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    background-color: #fafafa;
    @media (max-width: 1170px){
        display: none;
    }
    z-index: 10000;
    overflow-y: scroll;
    ::-webkit-scrollbar{
        display: none;
        width: 5px;
        height: 5px;
    }
    ::-webkit-scrollbar-thumb{
        border-radius: 1em;
        background-color: rgba(50,50,50,.3);
    }
    ::-webkit-scrollbar-track{
        border-radius: 1em;
        background-color: rgba(50,50,50,.1);
    }
    &:hover {
        ::-webkit-scrollbar{
            display: initial;
            width: 5px;
            height: 5px;
        }
    }
`;

const SidebarContentWrap = styled.div`
    display: flex;
    align-items: center;
    padding: 17px 0 17px 48px;
    color: ${props => props.isFocused ? '#de0606' : '#666'};
    font-size: 14px;
    font-weight: 400;
    transition: color .2s;
    svg, img {
        path, polygon, g { fill: ${props => props.isFocused ? '#de0606' : '#666'}; }
    }
    cursor: pointer;
    :hover {
        color: ${props => props.isActive === false ? 'transparent' : props.isFocused ? '#de0606' : '#666'};
        /* font-weight: 500; */
        background-color: hsl(0, 0%, 92%);
    }
    &:hover > svg {
        path,
        polygon,
            g {
                fill: ${props => props.isFocused ? '#de0606' : '#787878'};
            }
    }
`;
const SidebarContent = styled.div`
    margin-left: 10px;
`
const ChannelsWrap = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    border-top: 1px solid #e6e6e6;

`
const ChannelsTitle = styled.div`
    display: flex;
    padding: 16px 24px 8px 24px;
    font-weight: 400;
`
const Channel = styled.div`
    display: flex;
    align-items: center;
    min-height: 40px;
    padding-left: 24px;
    cursor: pointer;
    &:hover {
        background-color: #dedede;
    }
`
const ChannelContext = styled.div`
    max-width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    ${({ isLoading }) => isLoading ? `width: 110px; height: 1rem; border-radius: 8px; background-color: #dedede;` :''}
`
const Avatar = styled.div`
    position: relative;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border-radius: 100%;
    background-image: url('${props => props.imgUrl}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    ${props => props.isLoading ? `color: transparent; background-image: none; background-color: #dedede;` : ''}
`
const ArrowIconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`


// WEBPACK FOOTER //
// ./src/Sidebar.js